module.exports = __webpack_public_path__ + "img/bgerror.fddf70e7.png";